import type Model from '@ember-data/model';
import type { DetailedChangeset } from 'ember-changeset/types';
// eslint-disable-next-line ember/use-ember-data-rfc-395-imports
import type { ModelRegistry } from 'ember-data/model';
import getModelClassName from 'garaje/utils/get-model-class-name';

export default function isModel<M extends Model, T extends keyof ModelRegistry>(
  model: M,
  modelName: T,
): model is ModelRegistry[T] {
  return getModelClassName(model) === modelName;
}

export function isChangesetModel<M extends Model, T extends keyof ModelRegistry>(
  changeset: DetailedChangeset<M>,
  modelName: T,
): changeset is DetailedChangeset<ModelRegistry[T]> {
  return isModel(changeset.data, modelName);
}
